(function () {
    'use strict';

    angular.module('ib-passenger-tabs-module')
        .controller('PassengerTabsController', PassengerTabsController);

    PassengerTabsController.$inject = ['$scope', 'ApisFormConstants'];
    function PassengerTabsController ($scope, ApisFormConstants) {
        const vm = this;

        vm.currentTab;

        vm.changeTab = changeTab;
        vm.$onInit = activate;
        $scope.$on('completeNextFormEvent', completeNextForm);
        $scope.$on('setTabEvent', setTab);
        $scope.$on('setTabEventWithId', setTabId);


        ////////////////

        function activate () {
            vm.currentTab = 0;
        }

        /**
         * Changes the tab and updates the passengers status
         * @param {Integer} indexTab the index tab to be change
         */
        function changeTab (indexTab) {
            if (indexTab >= 0 && indexTab <= vm.passengersInfo.passengers.length) {
                updateTabStatus(vm.currentTab === vm.passengersInfo.passengers.length ? vm.passengersInfo.contactDataInfo :
                    vm.passengersInfo.passengers[vm.currentTab]);
                if (vm.currentTab + 1 < vm.passengersInfo.passengers.length && vm.passengersInfo.passengers[vm.currentTab + 1].basicInfo.isInfant) {
                    updateTabStatus(vm.passengersInfo.passengers[vm.currentTab + 1]);
                }
                vm.currentTab = indexTab;
                $scope.$broadcast('changeTabEvent', vm.currentTab, ApisFormConstants.TAB_SCROLL_ID + vm.currentTab);
            } else {
                updateTabStatus(vm.passengersInfo.contactDataInfo);
                $scope.$emit('updateSecurityInfoEvent');
            }
        }

        /**
         * updates the tabs component with the given tab index
         * @param {Object} event the event information
         * @param {Integer} indexTab the new Tab Index
         */
        function setTab (event, indexTab) {
            vm.currentTab = indexTab;
            $scope.$broadcast('changeTabEvent', vm.currentTab, ApisFormConstants.TAB_SCROLL_ID + vm.currentTab);
        }

        /**
         * Updates the tab component with the given tab id of passenger received
         * @param {Object} event Event
         * @param {Array} errorsPassenger Array with passenger with errors
         */
        function setTabId (event, errorsPassenger) {
            let j = 0, isFound = false, indexPassenger, firstIndex = true;
            for (let i = 0; i < vm.passengersInfo.passengers.length; i++) {
                for (let k = 0; k < errorsPassenger.length; k++) {
                    {
                        if (vm.passengersInfo.passengers[i].id === errorsPassenger[k].id.toString()) {
                            if (firstIndex) {
                                indexPassenger = i;
                                firstIndex = false;
                            }
                            vm.passengersInfo.passengers[i].formStatus = ApisFormConstants.TAB_STATES.WARNING;
                            while (!isFound && j < vm.passengersInfo.passengers.length) {
                                if (vm.passengersInfo.passengers[i].id === vm.passengersInfo.passengers[j].relatedParentId) {
                                    vm.passengersInfo.passengers[j].formStatus = ApisFormConstants.TAB_STATES.WARNING;
                                    isFound = true;
                                }
                                j++;
                            }
                        }
                    }
                }
            }
            setTab(null, indexPassenger);
        }

        /**
         * Updates the form status for the given object depending on current form state
         * @param {Object} tabModel the object to be updated
         */
        function updateTabStatus (tabModel) {
            let validChecks = false;
            let confirmEmergencyData = false;
            let usPrivacyEmergencyData = false;

            // checks 'us tracing'
            if (tabModel.id === undefined) {
                // tab contact data
                confirmEmergencyData = tabModel.confirmEmergencyData || false;
                usPrivacyEmergencyData = tabModel.usPrivacyEmergencyData || false;
            } else {
                // tab passengers data
                confirmEmergencyData = tabModel['confirmEmergencyData_' + tabModel.id] || false;
                usPrivacyEmergencyData = tabModel['usPrivacyEmergencyData_' + tabModel.id] || false;
            }

            validChecks = tabModel.allTrueInfo || (confirmEmergencyData && usPrivacyEmergencyData);
            tabModel.formStatus = vm.containerForm.$valid && (!tabModel.boardingCard || validChecks) ? ApisFormConstants.TAB_STATES.COMPLETED : ApisFormConstants.TAB_STATES.WARNING;
        }

        /**
         * Check the current form status and change to the next tab if exists. If not emits an event to update
         * the Apis information.
         * @param {Object} event the angular event object
         */
        function completeNextForm (event) {
            changeTab(vm.currentTab + 1);
        }
    }
})();
